"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6213],{

/***/ 19499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_spinners_kit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79608);
/* harmony import */ var react_spinners_kit__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_spinners_kit__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50066);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          background: ",
        ";\n\n          border: 2px solid ",
        ";\n\n          &:hover {\n            background-color: transparent;\n            color: var(--color-teal);\n\n            /* box-shadow: inset -8px -8px 24px var(--color-black-shadow); */\n          }\n        "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          background: ",
        ";\n          color: var(--color-teal) !important;\n          border: 2px solid ",
        ";\n\n          &:hover {\n            // background-color: var(--color-teal) !important;\n            // color: var(--color-white) !important;\n\n            /* box-shadow: inset -8px -8px 24px var(--color-black-shadow); */\n          }\n        "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          background: ",
        ";\n          border: 2px solid ",
        ";\n          color: var(--color-blue) !important;\n          &:hover {\n            // background-color: transparent;\n            // color: ",
        ";\n            // /* box-shadow: inset -8px -8px 24px var(--color-black-shadow); */\n          }\n        "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          background: ",
        ";\n          border: 2px solid ",
        ";\n\n          &:hover {\n            // background-color: transparent;\n            // color: ",
        ";\n            /* box-shadow: inset -8px -8px 24px var(--color-black-shadow); */\n          }\n        "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          background: ",
        ";\n          color: var(--color-white);\n          border: 2px solid ",
        ";\n\n          &:hover {\n            background: transparent;\n            color: ",
        ";\n          }\n        "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          background: transparent;\n          color: ",
        ";\n          border: 1px solid ",
        ";\n\n          &:hover {\n            background: ",
        ";\n            color: var(--color-white);\n          }\n        "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          background: transparent;\n          text-decoration: underline;\n          color: var(--color-black);\n          font-size: 24px;\n          font-weight: 700;\n          padding: 0;\n          max-width: initial;\n          width: initial;\n\n          &:hover {\n            color: ",
        ";\n          }\n        "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          background: var(--color-teal);\n          color: var(--color-white);\n          border: none !important;\n        "
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          // background: ",
        ";\n          // color: var(--color-white);\n          // border: 2px solid ",
        ";\n\n          &:hover {\n            // background-color: transparent;\n            // color: ",
        ";\n            /* background: ",
        "; */\n            /* box-shadow: inset -8px -8px 24px var(--color-black-shadow); */\n          }\n        "
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: transparent;\n      color: ",
        ";\n      border: 2px solid;\n    "
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 60px;\n  border-radius: 12px;\n  padding: 16px;\n\n  font-weight: bold;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n  line-height: 160%;\n  text-align: center;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: all 0.1s ease-in-out;\n  opacity: ",
        ";\n  @media (max-width: 767px) {\n    height: 50px;\n    line-height: 1;\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n\n  ",
        "\n\n  ",
        " @media ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  font-size: 18px;\n  font-weight: 400;\n  width: 100%;\n"
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n"
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}




const Style = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject10(), (param)=>{
    let { theme  } = param;
    return theme.fonts.primary;
}, (param)=>{
    let { theme  } = param;
    return theme.fontSizes.p.mobile;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.white.normal;
}, (param)=>{
    let { disabled  } = param;
    return disabled ? 0.5 : 1;
}, (param)=>{
    let { variant  } = param;
    switch(variant){
        case "secondary":
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject(), (param)=>{
                let { theme  } = param;
                return theme.colors.secondary.normal;
            }, (param)=>{
                let { theme  } = param;
                return theme.colors.secondary.normal;
            });
        case "primary":
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject1(), (param)=>{
                let { theme  } = param;
                return theme.colors.secondary.normal;
            }, (param)=>{
                let { theme  } = param;
                return theme.colors.secondary.normal;
            });
        case "tertiary":
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject2(), (param)=>{
                let { theme  } = param;
                return theme.colors.tertiary.normal;
            }, (param)=>{
                let { theme  } = param;
                return theme.colors.tertiary.normal;
            }, (param)=>{
                let { theme  } = param;
                return theme.colors.tertiary.normal;
            });
        case "success":
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject3(), (param)=>{
                let { theme  } = param;
                return theme.colors.success.normal;
            }, (param)=>{
                let { theme  } = param;
                return theme.colors.success.normal;
            }, (param)=>{
                let { theme  } = param;
                return theme.colors.success.normal;
            });
        case "info":
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject4(), (param)=>{
                let { theme  } = param;
                return theme.colors.info.normal;
            }, (param)=>{
                let { theme  } = param;
                return theme.colors.info.normal;
            }, (param)=>{
                let { theme  } = param;
                return theme.colors.info.normal;
            });
        case "infoReversed":
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject5(), (param)=>{
                let { theme  } = param;
                return theme.colors.info.normal;
            }, (param)=>{
                let { theme  } = param;
                return theme.colors.info.normal;
            }, (param)=>{
                let { theme  } = param;
                return theme.colors.info.normal;
            });
        case "link":
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject6(), (param)=>{
                let { theme  } = param;
                return theme.colors.primary.normal;
            });
        case "headerMain":
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject7());
        default:
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject8(), (param)=>{
                let { theme  } = param;
                return theme.colors.primary.normal;
            }, (param)=>{
                let { theme  } = param;
                return theme.colors.primary.normal;
            }, (param)=>{
                let { theme  } = param;
                return theme.colors.primary.normal;
            }, (param)=>{
                let { theme  } = param;
                return theme.colors.black;
            });
    }
}, (param)=>{
    let { filled , variant  } = param;
    return !filled && variant && variant !== "link" && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject9(), (param)=>{
        let { theme  } = param;
        return theme.colors[variant].normal;
    });
}, (param)=>{
    let { theme  } = param;
    return theme.breakpoints.tablet;
}, (param)=>{
    let { theme  } = param;
    return theme.fontSizes.p.mobile;
});
const StyledButton = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-68c44097-0"
})(_templateObject11(), Style);
const StyledLink = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-68c44097-1"
})(_templateObject12(), Style);
function Button(param) {
    let { variant ="primary" , filled =true , children , onClick , disabled =false , loading =false , loadingColor , href , className , target , type , ...rest } = param;
    const { colors  } = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .useTheme */ .Fg)();
    const contentOrLoadingSpinner = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: "flex justify-center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_spinners_kit__WEBPACK_IMPORTED_MODULE_3__.CircleSpinner, {
                size: 20,
                color: loadingColor !== null && loadingColor !== void 0 ? loadingColor : colors.white.normal
            })
        }) : children
    });
    if (href) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledLink, {
            href: href,
            disabled: disabled || loading,
            onClick: onClick,
            variant: variant,
            filled: filled,
            className: className,
            target: target,
            ...rest,
            children: contentOrLoadingSpinner
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButton, {
        disabled: disabled || loading,
        onClick: onClick,
        variant: variant,
        filled: filled,
        className: className,
        type: type,
        ...rest,
        children: contentOrLoadingSpinner
    });
}


/***/ }),

/***/ 44831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Tag; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50066);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background: ",
        ";\n      color: ",
        ";\n    "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n    "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          position: absolute;\n          top: 24px;\n          left: 24px;\n        "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          position: absolute;\n          top: 24px;\n          right: 24px;\n        "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          position: absolute;\n          bottom: 24px;\n          right: 24px;\n        "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          position: absolute;\n          bottom: 24px;\n          left: 24px;\n        "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          background: ",
        " !important;\n          border-color: ",
        " !important;\n          position: absolute;\n          bottom: 13px;\n          left: 24px;\n        "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          background: var(--color-teal) !important;\n          border-color: ",
        " !important;\n          position: absolute;\n          bottom: 13px;\n          left: 24px;\n        "
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        '\n\n  border-radius: 8px;\n  font-weight: 300;\n  font-family: "Fjalla One";\n  text-transform: uppercase;\n  line-height: 160%;\n  cursor: pointer;\n  white-space: nowrap;\n  font-size: 18px !important;\n  text-transform: uppercase;\n\n  &:hover {\n  }\n\n  ',
        "\n\n  ",
        "\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  line-height: 160%;\n  padding: 14px 24.5px;\n  font-size: ",
        ";\n\n  @media ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 10px;\n  padding: 8px;\n  line-height: 120%;\n  padding: 7px 10px;\n  font-size: ",
        ";\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}



const BaseTag = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-1063b772-0"
})(_templateObject8(), (param)=>{
    let { variant , theme , color , invertColors  } = param;
    let backgroundColor;
    let textColor;
    switch(variant){
        case "light":
            backgroundColor = "transparent";
            textColor = color;
            break;
        case "primary":
        case "follow":
            backgroundColor = theme.colors.tertiary.normal;
            textColor = "white";
            break;
        case "ideal":
            backgroundColor = theme.colors.secondary.normal;
            textColor = "white";
            break;
        default:
            backgroundColor = theme.colors.primary.normal;
            textColor = "white";
            break;
    }
    if (invertColors) {
        [backgroundColor, textColor] = [
            textColor,
            backgroundColor
        ];
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), backgroundColor, textColor);
}, (param)=>{
    let { isActive  } = param;
    return isActive && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1(), (param)=>{
        let { theme  } = param;
        return theme.colors.info.normal;
    }, (param)=>{
        let { theme  } = param;
        return theme.colors.white.normal;
    });
}, (param)=>{
    let { position  } = param;
    switch(position){
        case "tl":
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2());
        case "tr":
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject3());
        case "br":
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject4());
        case "bl":
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject5());
        case "blNew":
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject6(), (param)=>{
                let { theme  } = param;
                return theme.colors.secondary.normal;
            }, (param)=>{
                let { theme  } = param;
                return theme.colors.secondary.normal;
            });
        case "blNewNew":
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject7(), (param)=>{
                let { theme  } = param;
                return theme.colors.secondary.normal;
            });
        default:
            return;
    }
});
const StyledTag = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(BaseTag).withConfig({
    componentId: "sc-1063b772-1"
})(_templateObject9(), (param)=>{
    let { theme  } = param;
    return theme.fontSizes.p.mobile;
}, (param)=>{
    let { theme  } = param;
    return theme.breakpoints.tablet;
}, (param)=>{
    let { theme  } = param;
    return theme.fontSizes.p.desktop;
});
const StyledTagSmall = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(BaseTag).withConfig({
    componentId: "sc-1063b772-2"
})(_templateObject10(), (param)=>{
    let { theme  } = param;
    return theme.fontSizes.p.mobile;
});
function Tag(param) {
    let { variant ="light" , size ="l" , onClick , color ="var(--color-teal)" , children , position , isActive =false , invertColors =false , ...rest } = param;
    switch(size){
        case "m":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTagSmall, {
                position: position,
                onClick: onClick,
                variant: variant,
                color: color,
                isActive: isActive,
                invertColors: invertColors,
                ...rest,
                children: children
            });
        default:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTag, {
                position: position,
                onClick: onClick,
                variant: variant,
                color: color,
                isActive: isActive,
                invertColors: invertColors,
                ...rest,
                children: children
            });
    }
}


/***/ }),

/***/ 58969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_icons_IconWrapper_IconWrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6129);
/* harmony import */ var _components_icons_ImportantCircle_ImportantCircle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33935);




const HelperText = (param)=>{
    let { text  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: text && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "mt-3.5 flex items-center rounded-lg border-none bg-red-100 bg-opacity-75 p-3",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons_IconWrapper_IconWrapper__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    style: {
                        marginRight: 16
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons_ImportantCircle_ImportantCircle__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        className: "[&>path]:fill-red"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-red m-0 text-sm font-bold",
                    children: text
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HelperText);


/***/ }),

/***/ 60921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Input; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/debounce.js + 1 modules
var debounce = __webpack_require__(29296);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useMutation.js + 1 modules
var useMutation = __webpack_require__(98029);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-spinners-kit/lib/index.js
var lib = __webpack_require__(79608);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 48 modules
var axios = __webpack_require__(87066);
;// CONCATENATED MODULE: ./api/services/residence.service.ts

const ResidenceService = {
    getResidence: async (params, signal)=>{
        const response = await axios/* default.get */.Z.get("/api/residence", {
            params,
            signal
        });
        return response.data;
    }
};

// EXTERNAL MODULE: ./components/form/HelperText.tsx
var HelperText = __webpack_require__(58969);
// EXTERNAL MODULE: ./components/icons/IconWrapper/IconWrapper.tsx
var IconWrapper = __webpack_require__(6129);
// EXTERNAL MODULE: ./styles/theme.ts
var theme = __webpack_require__(18102);
;// CONCATENATED MODULE: ./utils/hooks/useIsMobileOS.ts

const useIsMobileOS = ()=>{
    const [isMobileOS, setIsMobileOS] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        const userAgent = window.navigator.userAgent;
        const isAndroid = /Android/i.test(userAgent);
        const isIOS = /iPad|iPhone|iPod/.test(userAgent) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
        setIsMobileOS(isAndroid || isIOS);
    }, []);
    return isMobileOS;
};
/* harmony default export */ var hooks_useIsMobileOS = (useIsMobileOS);

;// CONCATENATED MODULE: ./components/form/Input/Input.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        '\n        input[type="date"]::before {\n          content: ',
        ';\n          color: var(--color-input-placeholder) !important;\n          font-weight: 300 !important;\n          font-family: "Avenir" !important;\n          opacity: 1;\n        }\n      '
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          cursor: not-allowed;\n\n          .input-field {\n            opacity: 0.3;\n\n            input {\n              cursor: not-allowed;\n            }\n          }\n\n          footer {\n            opacity: 0.3;\n          }\n        "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          .input-field {\n            border-color: black;\n          }\n        "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n           .input-field {\n            background-color: var(--color-red-opacity-10);\n            border-color: var(--color-red);\n          }\n\n          footer {\n            svg path {\n              fill: var(--color-red);\n            }\n\n            p {\n              color: var(--color-red);\n            }\n          }\n        "
    ], [
        "\n          \\ .input-field {\n            background-color: var(--color-red-opacity-10);\n            border-color: var(--color-red);\n          }\n\n          footer {\n            svg path {\n              fill: var(--color-red);\n            }\n\n            p {\n              color: var(--color-red);\n            }\n          }\n        "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  cursor: text;\n  justify-content: space-between;\n  //height: ",
        ";\n  height: 100%;\n\n  label {\n    margin-bottom: 16px;\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 160%;\n\n    color: var(--color-white);\n\n    span.required-sign {\n      color: var(--color-orange);\n    }\n  }\n\n  .input-field {\n    border: 1px solid;\n    background-color: white;\n    width: 100%;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    padding: 10px 12px 10px 16px;\n\n    ",
        '\n    input {\n      border: none;\n      width: 100%;\n      margin-top: 3px;\n\n      font-weight: 400;\n      font-size: 18px;\n      line-height: 100%;\n      font-family: "Avenir" !important;\n      color: var(--color-input);\n      background-color: transparent;\n      min-height: 1.5rem;\n\n      ::placeholder {\n        color: var(--color-input-placeholder);\n        font-weight: 300 !important;\n        font-family: "Avenir" !important;\n        opacity: 1;\n      }\n\n      &:focus {\n        outline: 0;\n      }\n\n      &:placeholder-shown {\n        text-overflow: ellipsis;\n      }\n    }\n  }\n\n  footer {\n    display: flex;\n    align-items: center;\n    margin-top: 13.5px;\n  }\n\n  ',
        "\n\n  ",
        "\n\n    ",
        "\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}











const InputWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fdccfaab-0"
})(_templateObject4(), (param)=>{
    let { hasError  } = param;
    return hasError ? "100%" : "auto";
}, (param)=>{
    let { isMobileOS , hasValue  } = param;
    return isMobileOS && (0,styled_components_browser_esm/* css */.iv)(_templateObject(), hasValue ? "none" : "attr(placeholder)");
}, (param)=>{
    let { disabled  } = param;
    return disabled ? (0,styled_components_browser_esm/* css */.iv)(_templateObject1()) : null;
}, (param)=>{
    let { active  } = param;
    return active ? (0,styled_components_browser_esm/* css */.iv)(_templateObject2()) : null;
}, (param)=>{
    let { hasError  } = param;
    return hasError ? (0,styled_components_browser_esm/* css */.iv)(_templateObject3()) : null;
});
function Input(param) {
    let { iconLeft , iconRight , type ="text" , label , helperText , placeholder ="Vul hier je reactie in" , active =false , disabled =false , hasError =false , name , onChange , register , required , requiredSignColor =theme/* COLORS.tertiary.normal */.DM.tertiary.normal , labelClass , borderColor ="white" , extraDesc ="" , className , isResidenceInput , ...rest } = param;
    const { colors  } = (0,styled_components_browser_esm/* useTheme */.Fg)();
    const isMobileOS = hooks_useIsMobileOS();
    const [residenceSearch, setResidenceSearch] = (0,react.useState)("");
    const [residenceData, setResidenceData] = (0,react.useState)([]);
    const [showSuggestions, setShowSuggestions] = (0,react.useState)(false);
    const suggestionsRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (suggestionsRef.current && !suggestionsRef.current.contains(event.target)) {
                setShowSuggestions(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        suggestionsRef
    ]);
    const formRegister = register && name ? register(name, {
        required: required ? "Dit veld is verplicht" : false,
        valueAsNumber: type === "number"
    }) : {};
    const residenceMutation = (0,useMutation/* useMutation */.D)({
        mutationFn: async (searchQuery)=>{
            return await ResidenceService.getResidence({
                search: searchQuery
            }, new AbortController().signal);
        },
        onSuccess: (data)=>{
            const places = Array.from(new Set(data.features.map((feature)=>{
                return feature.properties.context.place.name;
            })));
            // Set residenceData to all unique "place" entries
            setResidenceData(places);
            // If residenceSearch is empty, clear residenceData
            if (residenceSearch === "") {
                setResidenceData([]);
            }
        }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedMutate = (0,react.useCallback)((0,debounce/* default */.Z)((searchQuery)=>{
        residenceMutation.mutate(searchQuery);
    }, 300), []);
    (0,react.useEffect)(()=>{
        if (isResidenceInput && residenceSearch !== "") {
            debouncedMutate(residenceSearch);
        }
    }, [
        residenceSearch,
        isResidenceInput,
        debouncedMutate
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputWrapper, {
        disabled: disabled,
        active: active,
        hasError: hasError,
        className: className,
        isMobileOS: isMobileOS,
        hasValue: !!rest.value,
        children: [
            !!label && /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                className: labelClass,
                children: [
                    label,
                    " ",
                    required && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "required-sign",
                        style: {
                            color: requiredSignColor
                        },
                        children: "*"
                    }),
                    " ",
                    extraDesc && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "extra-desc",
                        children: [
                            "(",
                            extraDesc,
                            ")"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            borderColor: colors[borderColor].normal
                        },
                        className: "input-field relative ".concat(hasError ? "error-input" : "", " ").concat(rest.hidden ? "hidden" : ""),
                        children: [
                            !!iconLeft && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper/* default */.Z, {
                                style: {
                                    marginRight: 10
                                },
                                children: iconLeft
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: type,
                                placeholder: placeholder,
                                ...formRegister,
                                ...rest,
                                value: isResidenceInput ? residenceSearch : rest.value,
                                onChange: (e)=>{
                                    onChange === null || onChange === void 0 ? void 0 : onChange(e);
                                    if (isResidenceInput) {
                                        setResidenceSearch(e.currentTarget.value);
                                        setShowSuggestions(true);
                                    }
                                }
                            }),
                            !!iconRight && !residenceMutation.isPending && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper/* default */.Z, {
                                style: {
                                    marginLeft: 10
                                },
                                children: iconRight
                            }),
                            residenceMutation.isPending && /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.CircleSpinner, {
                                size: 20,
                                color: theme/* COLORS.info.normal */.DM.info.normal
                            }),
                            isResidenceInput && showSuggestions && residenceData.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: suggestionsRef,
                                className: "absolute top-full left-0 z-10 mt-1 max-h-[200px] w-full overflow-y-auto rounded-lg bg-white",
                                children: residenceData.map((residence, index)=>{
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                        className: "cursor-pointer p-2",
                                        onClick: ()=>{
                                            setResidenceSearch(residence);
                                            onChange === null || onChange === void 0 ? void 0 : onChange({
                                                target: {
                                                    value: residence
                                                }
                                            });
                                            setResidenceData([]);
                                            setShowSuggestions(false);
                                        },
                                        children: residence
                                    }, index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HelperText/* default */.Z, {
                        text: helperText
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 6129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50066);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 5px 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}



const StyledIconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-82a05334-0"
})(_templateObject());
function IconWrapper(param) {
    let { children , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledIconWrapper, {
        ...rest,
        children: children
    });
}


/***/ }),

/***/ 33935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const ImportantCircle = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 21,
        height: 20,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M10.234 0c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10Zm1 15h-2v-2h2v2Zm0-4h-2V5h2v6Z",
            fill: "var(--color-red)"
        })
    });
/* harmony default export */ __webpack_exports__["Z"] = (ImportantCircle);


/***/ }),

/***/ 59509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PageWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var he__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86492);
/* harmony import */ var he__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(he__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50066);
/* harmony import */ var _components_buttons_BackToTopButton_BackToTopButton__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46896);
/* harmony import */ var _utils_url__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(24758);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n\n  .page-content {\n    flex: 1 0 auto;\n  }\n\n  footer {\n    shrink: 0;\n  }\n\n  @media ",
        ' {\n    &:before {\n      content: "";\n      // background: url("/Hero-bg-left.png");\n      background-repeat: repeat-y;\n      background-size: 377px, 407px, auto;\n      height: 100%;\n      width: 377px;\n      position: fixed;\n      left: 0;\n      top: 0;\n      z-index: -1;\n    }\n\n    &:after {\n      content: "";\n      // background: url("/Hero-bg-right.png");\n      background-repeat: repeat-y;\n      background-position: right;\n      background-size: 377px, 407px, auto;\n      height: 100%;\n      width: 377px;\n      position: fixed;\n      right: 0;\n      top: 0;\n      z-index: -1;\n    }\n  }\n'
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}










const DynamicFooter = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>Promise.all(/* import() */[__webpack_require__.e(8441), __webpack_require__.e(4481), __webpack_require__.e(5675), __webpack_require__.e(9162), __webpack_require__.e(3792), __webpack_require__.e(541)]).then(__webpack_require__.bind(__webpack_require__, 40541)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(40541)
            ]
    },
    loading: ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: "Loading..."
        })
});
const StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-876f2fea-0"
})(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.devices.laptop;
});
const defaultValues = {
    title: "Villa Pinedo",
    description: "Praten, lachen, klagen of huilen omdat je ouders gescheiden zijn kan bij Villa Pinedo op het forum of 1 op 1 met een Buddy. Je hoeft het niet alleen te doen.",
    canonical: "https://www.villapinedo.nl",
    image: "",
    ogtype: "website",
    oglocale: "nl_NL",
    ogurl: "https://www.villapinedo.nl"
};
function PageWrapper(param) {
    let { children , isHomepage , seo ={
        title: "Villa Pinedo",
        description: defaultValues.description,
        canonical: defaultValues.canonical,
        image: defaultValues.image,
        og: {
            type: defaultValues.ogtype,
            locale: defaultValues.oglocale,
            url: defaultValues.ogurl
        }
    }  } = param;
    var _seo_og, _seo_og1, _seo_og2, _seo_og3;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var _seo_title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_6__/* .NextSeo */ .PB, {
                title: "".concat(he__WEBPACK_IMPORTED_MODULE_2___default().decode((_seo_title = seo.title) !== null && _seo_title !== void 0 ? _seo_title : ""), " | ").concat(defaultValues.title),
                description: seo.description,
                canonical: seo.canonical || // If the current page is a dynamic route, use the asPath as the canonical URL so that the correct URL is used,
                // instead of the dynamic route URL (which contains the square brackets).
                "".concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_9__/* .getBaseUrl */ .SV)()).concat(router.pathname.indexOf("[") === -1 ? router.pathname : router.asPath),
                openGraph: {
                    title: seo.title,
                    description: seo.description,
                    images: seo.image ? [
                        {
                            url: seo.image,
                            width: 800,
                            height: 600,
                            alt: "Villa Pinedo"
                        }
                    ] : undefined,
                    type: (_seo_og = seo.og) === null || _seo_og === void 0 ? void 0 : _seo_og.type,
                    locale: (_seo_og1 = seo.og) === null || _seo_og1 === void 0 ? void 0 : _seo_og1.locale,
                    url: ((_seo_og2 = seo.og) === null || _seo_og2 === void 0 ? void 0 : _seo_og2.url) || seo.canonical,
                    site_name: "Villa Pinedo",
                    article: (_seo_og3 = seo.og) === null || _seo_og3 === void 0 ? void 0 : _seo_og3.article
                },
                twitter: {
                    handle: "@VillaPinedo",
                    cardType: "summary_large_image"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.ico"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "180x180",
                        href: "/apple-touch-icon.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "32x32",
                        href: "/favicon-32x32.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "16x16",
                        href: "/favicon-16x16.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                        rel: "manifest",
                        href: "/site.webmanifest"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                        rel: "mask-icon",
                        href: "/safari-pinned-tab.svg",
                        color: "#006ef7"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "msapplication-TileColor",
                        content: "#ffffff"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "theme-color",
                        content: "#ffffff"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "robots",
                        content: "index, follow"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        charSet: "UTF-8"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "page-content",
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_buttons_BackToTopButton_BackToTopButton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
            !isHomepage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DynamicFooter, {})
        ]
    });
}


/***/ })

}]);